import { createFileRoute, redirect } from "@tanstack/react-router";

import { loadNamespaces } from "../../app/i18n";
import { ReferralPage } from "../../areas/public/referral/ReferralPage";
import { normalizeReferralCode } from "../../areas/public/referral/referralStorage";

/**
 * Referral landing (FE-15 §5.3): public, no session. FR-FE15-09: a code with an invalid format goes
 * straight to registration without attribution.
 */
export const Route = createFileRoute("/r/$code")({
  beforeLoad: async ({ params }) => {
    if (!normalizeReferralCode(params.code)) {
      throw redirect({ to: "/app/register", search: {}, replace: true });
    }
    await loadNamespaces("public");
  },
  component: ReferralRoute,
});

function ReferralRoute() {
  const { code } = Route.useParams();
  return <ReferralPage code={normalizeReferralCode(code) ?? code.toUpperCase()} />;
}
